import reportTypes from '../actions/report.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {
        
        case reportTypes.CLEAR_REPORT:
        case reportTypes.GET_REPORT:
            return {
                ...state,
                data: [],
                filters: [],
                isLoading: true
            }
    
        case reportTypes.STORE_REPORT:

            if (action.payload != null) {

                const newData = {
                    id: action.payload.id,
                    nombre: action.payload.nombre,
                    descripcion: action.payload.descripcion,
                    fechaCorte: action.payload.fechaCorte,
                    data: action.payload.data
                };

                const newFilters = [...action.payload.filters];

                return {
                    ...state,
                    filters: newFilters,
                    data: newData,
                    isLoading: false
                }
            } else {
                return {
                    ...state,
                    data: [],
                    filters: [],
                    isLoading: false
                }
            }

        case reportTypes.FILTER_REPORT:
            return {
                ...state,
                isLoading: true
            }

        case reportTypes.CHANGE_DATA_REPORT:

            const newChangeDataReport = {
                id: action.payload.id,
                nombre: action.payload.nombre,
                descripcion: action.payload.descripcion,
                fechaCorte: action.payload.fechaCorte,
                data: action.payload.data
            };

            return {
                ...state,
                data: newChangeDataReport,
                isLoading: false
            }

        default:
            return state;
    }
};

export default reducer;

var initialEntries = {
    data: [],
    filters: []
};